/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ActorActivityRecordActorUserId } from './ActorActivityRecordActorUserId';
import {
    ActorActivityRecordActorUserIdFromJSON,
    ActorActivityRecordActorUserIdFromJSONTyped,
    ActorActivityRecordActorUserIdToJSON,
    ActorActivityRecordActorUserIdToJSONTyped,
} from './ActorActivityRecordActorUserId';
import type { GetInvoicesRequestPageSize } from './GetInvoicesRequestPageSize';
import {
    GetInvoicesRequestPageSizeFromJSON,
    GetInvoicesRequestPageSizeFromJSONTyped,
    GetInvoicesRequestPageSizeToJSON,
    GetInvoicesRequestPageSizeToJSONTyped,
} from './GetInvoicesRequestPageSize';
import type { InvoiceStatus } from './InvoiceStatus';
import {
    InvoiceStatusFromJSON,
    InvoiceStatusFromJSONTyped,
    InvoiceStatusToJSON,
    InvoiceStatusToJSONTyped,
} from './InvoiceStatus';
import type { GetInvoicesRequestPage } from './GetInvoicesRequestPage';
import {
    GetInvoicesRequestPageFromJSON,
    GetInvoicesRequestPageFromJSONTyped,
    GetInvoicesRequestPageToJSON,
    GetInvoicesRequestPageToJSONTyped,
} from './GetInvoicesRequestPage';

/**
 * 
 * @export
 * @interface GetInvoicesRequest
 */
export interface GetInvoicesRequest {
    /**
     * 
     * @type {any}
     * @memberof GetInvoicesRequest
     */
    billingDate?: any | null;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof GetInvoicesRequest
     */
    userId?: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof GetInvoicesRequest
     */
    studentId?: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof GetInvoicesRequest
     */
    locationId?: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {InvoiceStatus}
     * @memberof GetInvoicesRequest
     */
    status?: InvoiceStatus | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetInvoicesRequest
     */
    emailed?: boolean | null;
    /**
     * 
     * @type {GetInvoicesRequestPage}
     * @memberof GetInvoicesRequest
     */
    page?: GetInvoicesRequestPage;
    /**
     * 
     * @type {GetInvoicesRequestPageSize}
     * @memberof GetInvoicesRequest
     */
    pageSize?: GetInvoicesRequestPageSize;
}



/**
 * Check if a given object implements the GetInvoicesRequest interface.
 */
export function instanceOfGetInvoicesRequest(value: object): value is GetInvoicesRequest {
    return true;
}

export function GetInvoicesRequestFromJSON(json: any): GetInvoicesRequest {
    return GetInvoicesRequestFromJSONTyped(json, false);
}

export function GetInvoicesRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetInvoicesRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'billingDate': json['billingDate'] == null ? undefined : json['billingDate'],
        'userId': json['userId'] == null ? undefined : ActorActivityRecordActorUserIdFromJSON(json['userId']),
        'studentId': json['studentId'] == null ? undefined : ActorActivityRecordActorUserIdFromJSON(json['studentId']),
        'locationId': json['locationId'] == null ? undefined : ActorActivityRecordActorUserIdFromJSON(json['locationId']),
        'status': json['status'] == null ? undefined : InvoiceStatusFromJSON(json['status']),
        'emailed': json['emailed'] == null ? undefined : json['emailed'],
        'page': json['page'] == null ? undefined : GetInvoicesRequestPageFromJSON(json['page']),
        'pageSize': json['pageSize'] == null ? undefined : GetInvoicesRequestPageSizeFromJSON(json['pageSize']),
    };
}

export function GetInvoicesRequestToJSON(json: any): GetInvoicesRequest {
    return GetInvoicesRequestToJSONTyped(json, false);
}

export function GetInvoicesRequestToJSONTyped(value?: GetInvoicesRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'billingDate': value['billingDate'],
        'userId': ActorActivityRecordActorUserIdToJSON(value['userId']),
        'studentId': ActorActivityRecordActorUserIdToJSON(value['studentId']),
        'locationId': ActorActivityRecordActorUserIdToJSON(value['locationId']),
        'status': InvoiceStatusToJSON(value['status']),
        'emailed': value['emailed'],
        'page': GetInvoicesRequestPageToJSON(value['page']),
        'pageSize': GetInvoicesRequestPageSizeToJSON(value['pageSize']),
    };
}

